package team.platforma.multiplatform_material_extension.calendar.utils

import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.Month
import kotlinx.datetime.minus
import kotlinx.datetime.plus

internal fun setPreviousMonth(selectedDate: LocalDate): LocalDate {

    val currentMonth: Int
    val currentYear: Int

    if (selectedDate.monthNumber == 1) {
        currentMonth = 12
        currentYear = selectedDate.year - 1
    } else {
        currentMonth = selectedDate.monthNumber - 1
        currentYear = selectedDate.year
    }

    return LocalDate(
        currentYear,
        currentMonth,
        daysInMonth(currentYear, currentMonth)
    )
}

internal fun setNextMonth(selectedDate: LocalDate): LocalDate {

    val currentMonth: Int
    val currentYear: Int

    if (selectedDate.monthNumber == 12) {
        currentMonth = 1
        currentYear = selectedDate.year + 1
    } else {
        currentMonth = selectedDate.monthNumber + 1
        currentYear = selectedDate.year
    }

    return LocalDate(
        currentYear,
        currentMonth,
        daysInMonth(currentYear, currentMonth)
    )
}

internal fun isNextMonthInRange(currentDate: LocalDate, calendarRange: CalendarRange): Boolean {
    val nextMonth = if (currentDate.monthNumber == 12) 1 else currentDate.monthNumber + 1
    val nextYear = if (currentDate.monthNumber == 12) currentDate.year + 1 else currentDate.year

    val startOfNextMonth = LocalDate(nextYear, nextMonth, 1)
    val endOfNextMonth = LocalDate(nextYear, nextMonth, daysInMonth(nextYear, nextMonth))

    return (startOfNextMonth in calendarRange.max..calendarRange.min) || (endOfNextMonth in calendarRange.max..calendarRange.min)
}

internal fun isPreviousMonthInRange(currentDate: LocalDate, calendarRange: CalendarRange): Boolean {
    val previousMonth = if (currentDate.monthNumber == 1) 12 else currentDate.monthNumber - 1
    val previousYear = if (currentDate.monthNumber == 1) currentDate.year - 1 else currentDate.year

    val startOfPreviousMonth = LocalDate(previousYear, previousMonth, 1)
    val endOfPreviousMonth =
        LocalDate(previousYear, previousMonth, daysInMonth(previousYear, previousMonth))

    return (startOfPreviousMonth in calendarRange.max..calendarRange.min) || (endOfPreviousMonth in calendarRange.max..calendarRange.min)
}

internal fun daysInMonth(year: Int, month: Int): Int {
    return when (month) {
        1, 3, 5, 7, 8, 10, 12 -> 31
        4, 6, 9, 11 -> 30
        2 -> if (isLeapYear(year)) 29 else 28
        else -> throw IllegalArgumentException("Invalid month: $month")
    }
}

/**
 * Проверка на високосный год.
 */
internal fun isLeapYear(year: Int): Boolean {
    return (year % 4 == 0 && year % 100 != 0) || (year % 400 == 0)
}

internal fun setStandardCalendarRange(currentDate: LocalDate): CalendarRange {
    return CalendarRange(
        min = currentDate.plus(DatePeriod(years = 10)).run {
            LocalDate(year, Month.DECEMBER, 31)
        },
        max = currentDate.minus(DatePeriod(years = 70)).run {
            LocalDate(year, Month.JANUARY, 1)
        }
    )
}

internal fun getAllDatesInMonth(year: Int, monthNumber: Int): List<LocalDate> {
    val lastDayOfMonth = daysInMonth(year, monthNumber)
    return (1..lastDayOfMonth).map { day ->
        LocalDate(year, monthNumber, day)
    }
}